/*
    environment.js
        Use this file to store environment path and export to other files.
        isIE is used to check if the browser is internet explorer and if it is
        then display error message.
*/

/* LOCAL RUN FROM scdc-public-html env
        when running scdc-public-html locally through npm run start you need to point
        env to local tomcat. Make sure tomcat is running locally on computer with scdc-public and then uncomment this env
        and comment out the embedded env. This env points to the running backend on java app.
*/
//export const env = "http://localhost:8080/scdc-public/";

/* EMBEDDED ENV
        When running application when embedded in java web app use this env.
        This env points it to itself. This is the env needed for production
*/
export const env = "/scdc-public/";

// Used to detect if browser is internet explorer to display message
export const isIE = /*@cc_on!@*/ false || !!document.documentMode;
